const faqs = [
  {
    id: 1,
    heading: "What are the standard sizes for postcards?",
    content: "Standard postcard sizes typically include 4\" x 6\", 5\" x 7\", and 5.5\" x 8.5\". These dimensions are ideal for mailing and ensure cost-effective printing and postage.",
  },
  {
    id: 2,
    heading: "What are the most common sizes for brochures?",
    content: "Common brochure sizes include 8.5\" x 11\" (tri-fold), 11\" x 17\" (half-fold), and 8.5\" x 14\". The size often depends on the layout and information density.",
  },
  {
    id: 3,
    heading: "What are Pantone colors?",
    content: "Pantone colors are standardized color codes used across industries to ensure color consistency. Designers use them to match specific shades accurately in print.",
  },
  {
    id: 4,
    heading: "What is color separation?",
    content: "Color separation is a prepress process where artwork is divided into individual color components—typically CMYK—so each color can be printed separately.",
  },
  {
    id: 5,
    heading: "What is halftone printing?",
    content: "Halftone printing uses tiny dots of varying sizes and spacing to simulate gradients and shades. It allows full-color images to be reproduced using fewer inks.",
  },
];

export default faqs;